<template>
	<el-header class='header' height='70px'>
		<div style="margin-right: 20px;"><span>制作剩余订单次数：{{app_info.total_num-app_info.total_used}}次</span></div>
		<div id='charge-button' @click="toPay">充值</div>
		<div style="margin-right: 20px;">
			<span>{{user?user:"未登录"}}</span>
		</div>	
		<el-dropdown>
			<img id='user-icon' src="../assets/icon_account@2x.png">
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item @click.native="logout">退出</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
	</el-header>
</template>

<script>
	import {
		mapState
	} from "vuex";
	export default {
		data() {
			return {
				
			}
		},
		computed:{
			...mapState([
				"app_info","user"
			])
		},
		methods: {
			logout() {
				var keys = document.cookie.match(/[^ =;]+(?=)/g);
				if (keys) {
					for (var i = keys.length; i--;)
						document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString()
				}
				localStorage.clear()
				this.$router.replace('/login')
			},
			toPay:function(){
				this.$router.push('/pay')
			}
		},
		created() {
			
		},
		
	}
</script>

<style scoped="scoped">
.header{
	padding: 0 30px 0 0;
	box-shadow: 0px 4px 8px 0px rgba(63, 63, 63, 0.1);
	display: flex;
	align-items: center;
	justify-content: flex-end;
	font-size: 14px;
	color: #4C4C4C;
}

#user-icon{
	width: 30px;
	height: 30px;
}
#charge-button{
	width: 90px;
	height: 36px;
	background: #287AFF;
	border-radius: 6px;
	font-size: 16px;
	font-weight: bold;
	color: #FFFFFF;
	line-height: 36px;
	text-align: center;
	margin-right: 40px;
	cursor: pointer;
}
</style>
